import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function saveAjudante(ajudante) {
  try {
    const response = await authHttp().post(routes.urlPostAjudante, ajudante)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getAjudantes(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetAjudantes(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getAjudantesAtivos(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetAjudantesAtivos(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
